import { Container, Modal } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import ReasonCodeModalFormComponent from "./ReasonCodeModalFormComponent";
import {
  commentModalInitValues,
  MODIFIED,
  MOH,
  ADMIN,
} from "../../Helpers/constants";

const getUploadedFile = (values, rowValues) => {
  if (values.file)
    return { fileName: values.file, fileDownloadUri: values.file };
  else
    return {
      fileName: rowValues.attachmentName,
      fileDownloadUri: rowValues.attachmentPath,
    };
};

const ReasonCodeModal = ({
  toggleModal,
  isModalOpen,
  rowValues,
  changeStatus,
  doApprove,
  translate,
  nestedModal,
  setNestedModal,
  closeAll,
  setCloseAll,
  setSpinnerStatus,
  isCloned,
  status,
  userRole,
  setValues = () => {},
}) => {
  // eliminato MANAGER rispetto a quello globale
  const ROLES_TO_SEE_STATUS = [MOH, ADMIN];
  const isAdmin = ROLES_TO_SEE_STATUS.includes(userRole);
  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Required"),
  });

  const handleModalState = (state) => {
    toggleModal(state);
    setValues(null);
  };

  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setCloseAll(false);
  };
  const toggleAll = () => {
    setNestedModal(!nestedModal);
    setCloseAll(true);
  };

  return (
    <Container fluid>
      <Modal
        isOpen={isModalOpen}
        toggle={() => handleModalState(false)}
        size="lg"
      >
        <Formik
          initialValues={{
            ...commentModalInitValues,
            ...rowValues,
            status: isAdmin
              ? rowValues?.status
              : (rowValues?.status ?? MODIFIED),
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const status =
              values.userComment && values.userComment !== rowValues.userComment
                ? MODIFIED
                : values.status;
            changeStatus(
              setSpinnerStatus,
              doApprove,
              rowValues.rowId,
              rowValues.modelId,
              rowValues.orgVersionId,
              status,
              values.comment,
              values.reasonCodeId,
              values.userComment,
              getUploadedFile(values, rowValues),
            );
            handleModalState(false);
          }}
        >
          {(props) => (
            <ReasonCodeModalFormComponent
              {...props}
              translate={translate}
              toggleModal={handleModalState}
              nestedModal={nestedModal}
              closeAll={closeAll}
              toggleAll={toggleAll}
              toggleNested={toggleNested}
              isCloned={isCloned}
              orgVersionStatus={status}
              userRole={userRole}
              isAdmin={isAdmin}
              readOnly={rowValues?.readOnly}
            />
          )}
        </Formik>
      </Modal>
    </Container>
  );
};
export default ReasonCodeModal;
